import React, { Children, Fragment } from 'react'
import * as ReactDOM from 'react-dom'
import { Icon } from 'antd'

export interface IDialogProps {
	hiddenHeader?: boolean
	opacity?: number
	top?: number
	width?: number
	height?: number
	maxHeight?: number
	maxWidth?: number
	size?: 'small' | 'full'
	title?: string
}
let globalDialogInstance: any[] = []

export default {
	open<P>(component?: React.ReactElement<P>, dialog?: IDialogProps): Promise<any> {
		return new Promise(resolve => {
			let div = document.createElement('div')
			div.className = 'app-dialog-main'
			div.id = '_app_dialog_main'

			document.body.appendChild(div)
			document.body.style.overflow = 'hidden'
			let onClose = () => {
				this.close()
				resolve()
			}

			let fullWidth = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth
			let fullHeight = document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight
			let width = 0
			let height = 0

			if (dialog && dialog.size && dialog.size === 'full') {
				width = fullWidth - 150
				height = fullHeight - 100
			}

			if (dialog && dialog.width) {
				width = dialog.width
			}
			if (dialog && dialog.height) {
				height = dialog.height
			}

			width = width === 0 ? 500 : width
			height = height === 0 ? 300 : height

			if (dialog && dialog.maxHeight) {
				height = height > dialog.maxHeight ? dialog.maxHeight : height
			}

			if (dialog && dialog.maxWidth) {
				width = width > dialog.maxWidth ? dialog.maxWidth : width
			}

			width = width > fullWidth - 150 ? fullWidth - 150 : width
			height = height > fullHeight - 100 ? fullHeight - 100 : height

			let left = (fullWidth - width) / 2
			let top = (fullHeight - height) / 2

			/*设置app-dialog-body的高度*/
			let bodyHeight = height - 40

			let content = (
				<Fragment>
					<div className="app-dialog" style={{ left, top, width, height }}>
						<div className="app-dialog-head">
							<label>{dialog ? dialog.title || '' : ''}</label>
							<div className="app-dialog-close" onClick={onClose}>
								<Icon type="close" />
							</div>
						</div>

						<div className="app-dialog-body" style={{ height: bodyHeight }}>
							{component}
						</div>
					</div>
					<div className="app-dialog-shadow"></div>
				</Fragment>
			)

			ReactDOM.render(content, div)
			globalDialogInstance.push(div)
		})
	},
	close() {
		requestAnimationFrame(() => {
			let div = globalDialogInstance.pop()
			const unmountResult = ReactDOM.unmountComponentAtNode(div)
			if (unmountResult && div.parentNode) {
				div.parentNode.removeChild(div)
			}
		})
	},
}



// WEBPACK FOOTER //
// ./src/components/AppDialog/index.tsx